import { useNavigate } from 'react-router-dom';
import QuizModule from '../components/QuizModule';
import { useSeo } from '../lib/useSeo';

export default function QuizPage() {
  const navigate = useNavigate();
  useSeo({
    title: 'Quiz: jaki system AI da Ci najwięcej? - DAIEN',
    description: 'Odpowiedz na kilka pytań i sprawdź, który system AI (lead gen, voice agent, RAG, automatyzacja) najszybciej zwróci się w Twojej firmie. 2 minuty, bez zobowiązań.',
    path: '/quiz',
  });
  return <QuizModule isActive={true} onClose={() => navigate('/')} />;
}
